import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import syncFill from '@iconify/icons-eva/sync-fill';
import { makeStyles } from '@material-ui/styles';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import moment from 'moment';
import Controls from '../controls/Controls';

import { useConstantsContext } from '../../context/constants_context';
import { useClientContext } from '../../context/client_context';
import {
  baseUrl,
  gender,
  maritalState,
  employers,
  titles,
  employerCodes,
  memberStatuses,
  terminationReasons,
  tierSchemes,
  relationShips
} from '../../utils/constants';
import DependantSub from './DependantSub';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#f5f5f5'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function PersonalDetails() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { towns, suburbs, banks, bankBranches } = useConstantsContext();
  const { clientRefId, currentClient, setClientRefId, setCurrentClient, clientBankingDetails } =
    useClientContext();
  const [formData, setFormData] = useState(null);
  const [newMember, setNew] = useState(true);
  const [operation, setOperation] = useState('save');
  const [loading, setLoading] = useState(false);
  const [isMain, setMain] = useState(true);
  const [isDisabled, setDisabled] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });
  const [branchList, setBranchList] = useState([
    {
      refId: 0,
      name: 'No Bank Selected'
    }
  ]);

  const PersonalDetailsSchema = Yup.object().shape({
    // firstName: Yup.string()
    //   .min(2, 'First Name is too Short!')
    //   .max(50, 'First Name is too Long!')
    //   .required('First name required'),
    // surname: Yup.string()
    //   .min(2, 'Surname is too Short!')
    //   .max(50, 'Surname is too Long!')
    //   .required('Last name required'),
    // emailAddress: Yup.string().email('Email must be a valid email address'),
    // cellNumber: Yup.number().required('Cell Number is required'),
    // dateOfBirth: Yup.date()
  });

  const initialValue = {
    firstName: currentClient.firstName,
    surname: currentClient.surname,
    idNumber: currentClient.idNumber,
    dateOfBirth: moment(currentClient.dateOfBirth).format('yyyy-MM-DD'),
    membershipStartDate: moment(currentClient.membershipStartDate).format('yyyy-MM-DD'),

    gender: currentClient.gender,
    addressLine1: currentClient.addressLine1,
    addressLine2: currentClient.addressLine2,
    addressLine3: currentClient.addressLine3,
    provinceLookupKey: currentClient.provinceLookupKey,
    cellNumber: currentClient.cellNumber,
    emailAddress: currentClient.emailAddress,
    maritalStatus: currentClient.maritalStatus,
    employerRefId: currentClient.employerRefId,
    paypointRefId: currentClient.paypointRefId,
    postalCode: currentClient.postalCode,
    group_id: currentClient.group_id,
    sex_ID: currentClient.sex_ID,
    title_id: currentClient.title_id,
    age: currentClient.age,
    principalSchemeID: currentClient.principalSchemeID,
    physical_Town_ID: currentClient.physical_Town_ID,
    physical_Suburb_ID: currentClient.physical_Suburb_ID,
    bank_ID: currentClient.bank_ID,
    acc_No: currentClient.acc_No,
    acc_Name: currentClient.acc_Name,
    home_Phone: currentClient.home_Phone,
    postal_Phone: currentClient.postal_Phone,
    physical_Add1: currentClient.physical_Add1,
    accName: currentClient.accName
  };

  useEffect(() => {
    setFormData(initialValue);
  }, [clientRefId]);

  const formik = useFormik({
    initialValues: currentClient,
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      console.log('custingo before that exe 2', values);
      if (operation === 'save') {
        saveClientData(values);
      } else if (operation === 'terminate') {
        terminateMember(values);
      } else if (operation === 'reinstate') {
        reinstateMember(values);
      } else if (operation === 'registerLogin') {
        createLogin(values);
      } else if (operation === 'resendPassword') {
        resendPassword(values.cellNumber);
      } else if (operation === 'showPassword') {
        showPassword(values.cellNumber);
      }
    }
  });

  currentClient.dateOfBirth = moment(currentClient.dateOfBirth).format('yyyy-MM-DD');
  // setMemberNo(currentClient.memberShipNo);
  currentClient.membershipStartDate = moment(currentClient.membershipStartDate).format(
    'yyyy-MM-DD'
  );
  currentClient.retirementDate = moment(currentClient.retirementDate).format('yyyy-MM-DD');
  if (currentClient.termdate)
    currentClient.termdate = moment(currentClient.termdate).format('yyyy-MM-DD');
  const date1 = moment(currentClient.dateOfBirth);
  const date2 = moment();
  const diff = date2.diff(date1, 'years');
  currentClient.age = diff;

  const handleFormUpdate = (e) => {
    saveClientData(e);
  };

  const saveClientData = (client) => {
    const jsonClient = [];
    jsonClient.push(client);
    console.log('client stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/SaveClient`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setClientRefId(result.refId);
          setCurrentClient(result);
          notifyPopup(`Member changes saved successfully!`, 'success');
        },
        (error) => {
          notifyPopup(`Error in Saving Member Changes, Changes not effected!: ${error}`, 'error');
        }
      );
  };

  const handleSchemeSubmit = async (e) => {
    if (newMember) {
      formik.setFieldValue('principalSchemeID', e.target.value);
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false
      });
      return;
    }
    console.log('came here to submit');
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    console.log('Scheme of eeeeeeeee', e.target.value);
    if (e.target.value === 0) {
      notifyPopup(`Scheme was not changed!`, 'error');
      return;
    }
    setLoading(true);
    await axios
      .post(
        `${baseUrl}/api/client/UpdateMemberScheme?cif_no=${currentClient.cif_number}&newScheme=${e.target.value}`
      )
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Changing Scheme!: ${result.replyMessage}`, 'error');
          } else {
            console.log('returned doc', result);
            formik.setFieldValue('principalSchemeID', e.target.value);
            navigate('/dashboard', { replace: true });
          }
        },
        (error) => {
          notifyPopup(`Error in Changing Scheme..Client Scheme not Changed!: ${error}`, 'error');
        }
      );
  };

  const handleMemberNumberChange = async (e) => {
    console.log('e from number', e);
    console.log('e from values', formik.values.memberShipNo);
    console.log('e from cif_number', formik.values.cif_number);
    console.log('e from memberShipNo', currentClient.memberShipNo);

    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });

    if (currentClient.memberShipNo === formik.values.memberShipNo) {
      notifyPopup(`Ooops, you forgot to change the Membership #!`, 'error');
      return;
    }

    if (currentClient.cif_number !== formik.values.parent_Cif) {
      notifyPopup(`Not Allowed to change Membership # from a Dependant profile!`, 'error');
      return;
    }

    setLoading(true);
    const user = sessionStorage.getItem('oldRefId');
    await axios
      .post(
        `${baseUrl}/api/client/UpdateMemberNumber?cif_no=${currentClient.cif_number}&oldNumber=${currentClient.memberShipNo}&newNumber=${formik.values.memberShipNo}
        &user=${user} `
      )
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Membership #!: ${result.replyMessage}`, 'error');
          } else {
            console.log('returned change', result);
            navigate('/dashboard', { replace: true });
          }
        },
        (error) => {
          notifyPopup(`Error in Changing Member #..Client Number not Changed!: ${error}`, 'error');
        }
      );
  };

  const handleGroupChange = async (e) => {
    if (newMember) {
      formik.setFieldValue('group_id', e.target.value);

      setConfirmDialog({
        ...confirmDialog,
        isOpen: false
      });
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    if (e.target.value === 0) {
      notifyPopup(`group_id was not changed!`, 'error');
      return;
    }

    setLoading(true);
    const user = sessionStorage.getItem('oldRefId');
    await axios
      .post(
        `${baseUrl}/api/client/UpdateMemberGroup?cif_no=${currentClient.cif_number}&oldGroup=${currentClient.group_id}&newGroup=${e.target.value}
        &user=${user}&newMemberNo=${formik.values.memberShipNo} `
      )
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Changing Scheme!: ${result.replyMessage}`, 'error');
          } else {
            console.log('returned doc', result);
            formik.setFieldValue('group_id', e.target.value);
            navigate('/dashboard', { replace: true });
          }
        },
        (error) => {
          notifyPopup(`Error in Changing Scheme..Client Scheme not Changed!: ${error}`, 'error');
        }
      );
  };

  const terminateMember = (value) => {
    console.log('sessionStorage.getIt', value);
    if (sessionStorage.getItem('oldRefId') !== '6') {
      notifyPopup(`Only Supervisor Can Terminate Member...Member not terminated!`, 'error');
      formik.setFieldValue('termdate', '');
      formik.setFieldValue('reasonForTerm', '');
      return;
    }
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(value);
    fetch(
      `${baseUrl}/api/client/setSsbRecordForDelete?terminated_by=${sessionStorage.getItem(
        'oldRefId'
      )}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(jsonClient[0])
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('from terminate', result);
          if (result.replyStatus === 0) {
            notifyPopup(`Member SSB Termination Record Successfully!`, 'success');
            navigate('/dashboard', { replace: true });
          } else {
            notifyPopup(`Error in Terminating Client!: ${result.result.replyMessage}`, 'error');
          }
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Terminating Client..!: ${error}`, 'error');
        }
      );
  };

  const reinstateMember = (value) => {
    setLoading(true);
    const reinstateDate = moment();
    fetch(
      `${baseUrl}/api/client/ReinstateMember?cif_no=${value.cif_number}&reinstation_date=${moment(
        reinstateDate
      ).format('YYYY-MM-DD')}&terminated_by=${sessionStorage.getItem('oldRefId')}&dependants=${
        value.dependents
      }&group_id=${value.group_id}&anniv_date=${moment(reinstateDate).format(
        'YYYY-MM-DD'
      )}&schemeID=${value.principalSchemeID}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('from reinstate', result);
          if (result.result.replyStatus === 0) {
            notifyPopup(`Member Reinstated Successfully!`, 'success');
            navigate('/dashboard', { replace: true });
          } else {
            notifyPopup(`Error in Reinstating Client!: ${result.result.replyMessage}`, 'error');
          }
        },
        (error) => {
          notifyPopup(`Error in Reinstating Client..!: ${error}`, 'error');
        }
      );
  };

  const createLogin = async (e) => {
    if (e.cellNumber === null || e.cellNumber === undefined) {
      notifyPopup(`Client has no cell number, please update Cell number first!`, 'error');

      setConfirmDialog({
        ...confirmDialog,
        isOpen: false
      });
      return;
    }
    // if (e.emailAddress === null || e.emailAddress === undefined) {
    //   notifyPopup(`Client has no Email Address, please update Email Address first!`, 'error');

    //   setConfirmDialog({
    //     ...confirmDialog,
    //     isOpen: false
    //   });
    //   return;
    // }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });

    setLoading(true);
    const jsonClient = [];

    const userPayload = {
      emailAddress: e.emailAddress ?? e.cellNumber,
      password: swapFirstAndLast(e.idNumber.substring(3, 7)),
      confirmPassword: swapFirstAndLast(e.idNumber.substring(3, 7)),
      firstName: e.firstName,
      surname: e.surname,
      cellNumber: e.cellNumber,
      companyName: 'ZIMTA Member',
      countryRefId: 1,
      userType: 3,
      dept: 6,
      systemLanguage: 0
    };
    jsonClient.push(userPayload);
    console.log('register user now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/serviceAuthentication/registerUser`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned register', res);
          setLoading(false);
          if (res.replyStatus === 1) {
            notifyPopup(`Error in registerUser!: ${res.replyMessage}`, 'error');
          } else {
            console.log('returned registerUser', res);
            navigate('/dashboard', { replace: true });
          }
        },
        (error) => {
          notifyPopup(`Error in registerUser, Login not registered!: ${error}`, 'error');
        }
      );
  };

  const resendPassword = async (e) => {
    setLoading(true);
    await axios.post(`${baseUrl}/api/client/ResendUserPassword?username=${e}`).then(
      (result) => {
        console.log('returned passw', result);
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Resending Password to User!: ${result.replyMessage}`, 'error');
        } else {
          notifyPopup(`Password re-sent successfully to user!: ${result.replyMessage}`, 'success');
        }
      },
      (error) => {
        notifyPopup(`Error in Resending Password to User..Password not sent!: ${error}`, 'error');
      }
    );
  };

  const showPassword = async (e) => {
    fetch(`${baseUrl}/api/serviceAuthentication/GetUserPassword?username=${e}`)
      .then((result) => result.json())
      .then(
        (result) => {
          console.log('result get password: ', result);
          notifyPopup(`${result.replyMessage}`, 'success');
        },
        (error) => {
          console.log('error', error);
        }
      );
  };

  const swapFirstAndLast = (value) => {
    const { length } = value;
    return value.charAt(length - 1) + value.substring(1, length - 1) + value.charAt(0);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const closePopup = () => {
    setOpenPopup(false);
    navigate('/dashboard', { replace: true });
  };

  const { errors, touched, getFieldProps } = formik;

  return (
    <Card>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              {!currentClient.cif_number && (
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="memberShipNo" label="Member #" />
                </Grid>
              )}
              {currentClient.cif_number > 0 && (
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    type="text"
                    size="small"
                    value={formik.values.memberShipNo}
                    {...getFieldProps('memberShipNo')}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            onClick={(e) =>
                              setConfirmDialog({
                                isOpen: true,
                                title: 'Are you sure you want to Change Membership Number',
                                subTitle: 'All Dependants will be changed also',
                                heading: 'Change Membership #',
                                color: 'primary',
                                onConfirm: () => {
                                  handleMemberNumberChange(e);
                                }
                              })
                            }
                          >
                            <Icon icon={syncFill} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    error={Boolean(touched.memberShipNo && errors.memberShipNo)}
                    helperText={touched.memberShipNo && errors.memberShipNo}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={3}>
                <Controls.SelectJson
                  name="group_id"
                  label="Group"
                  options={employerCodes}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="group_idlabel">Group</InputLabel>
                  <Select
                    id="group_id"
                    value={formik.values.group_id}
                    name="group_id"
                    fullWidth
                    size="small"
                    variant="outlined"
                    disabled={!isMain}
                    onChange={(e) =>
                      setConfirmDialog({
                        isOpen: true,
                        title: 'Are you sure you want to Change Member Group',
                        subTitle: 'Always Change Member # before Group!!!!',
                        heading: 'Change Member Group',
                        color: 'primary',
                        onConfirm: () => {
                          handleGroupChange(e);
                        }
                      })
                    }
                  >
                    {employers.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Divider
                style={{ background: '#1a237e', height: 2, margin: 2, width: '90%', paddingTop: 4 }}
                variant="middle"
              />
              <Grid item xs={12} sm={2}>
                <Controls.SelectJson name="title_id" label="Title" options={titles} />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="firstName" label="First Name" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="surname" label="Last Name" />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.Input name="idNumber" label="Id Number" />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.DateTime name="dateOfBirth" label="Date Of Birth" />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.SelectJson name="sex_ID" label="Gender" options={gender} />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Controls.Input name="age" label="Age" />
              </Grid>

              <Grid item xs={12} sm={2}>
                <Controls.Input name="dpt" label="Dept" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Controls.Input name="stn" label="Stn" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="station" label="Station" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="dist" label="District" />
              </Grid>
              {isMain && (
                <Grid item xs={12} sm={2} paddingBottom={2}>
                  <Controls.Input name="dependents" label="# of Dependants" />
                </Grid>
              )}
              <Grid item xs={12} sm={4} paddingBottom={2}>
                <Controls.SelectJson
                  name="maritalStatus"
                  label="Marital Status"
                  options={maritalState}
                />
              </Grid>
              <Grid item xs={12} sm={4} paddingBottom={2}>
                <Controls.Input name="cellNumber" label="Cell Number (Mobile access)" />
              </Grid>

              <Divider
                style={{ background: '#1a237e', height: 2, margin: 2, width: '90%', paddingTop: 4 }}
                variant="middle"
              />
              <Grid item xs={12} sm={4}>
                <Controls.SelectJson
                  name="relationship_ID"
                  label="Relationship to Main"
                  options={relationShips}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="suffix" label="Suffix" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.DateTime name="retirementDate" label="Retirement Date" />
              </Grid>
              {/* <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="tierLabel">Tier Scheme</InputLabel>
                  <Select
                    id="principalSchemeID"
                    value={formik.values.principalSchemeID}
                    name="principalSchemeID"
                    fullWidth
                    size="small"
                    variant="outlined"
                    disabled={!isMain}
                    onChange={(e) =>
                      setConfirmDialog({
                        isOpen: true,
                        title: 'Are you sure you want to Update Member Scheme',
                        subTitle: 'To Undo you have to change again',
                        heading: 'Change Member Scheme',
                        color: 'primary',
                        onConfirm: () => {
                          handleSchemeSubmit(e);
                        }
                      })
                    }
                  >
                    {tierSchemes.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid item xs={12} sm={4} paddingBottom={2}>
                <Controls.SelectJson
                  name="memberStatus"
                  label="Member Status"
                  options={memberStatuses}
                />
              </Grid>
              <Grid item xs={12} sm={4} paddingBottom={2}>
                <Controls.DateTime name="membershipStartDate" label="Membership Start Date" />
              </Grid>
              <Grid item xs={12} sm={4} paddingBottom={2}>
                <Controls.Input name="clothingSize" label="T-Shirt Size" />
              </Grid>
            </Grid>
            <div className={classes.root}>
              <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Contact and Address</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2} marginTop={2}>
                    <Grid item xs={12} sm={6}>
                      <Paper variant="outlined" margin={10}>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="physical_Add1" label="Physical Address" />
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <FormControl fullWidth>
                            <InputLabel id="suburbLabel">Suburb</InputLabel>
                            <Select
                              id="physical_Suburb_ID"
                              value={formik.values.physical_Suburb_ID}
                              name="physical_Suburb_ID"
                              fullWidth
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                formik.setFieldValue('physical_Suburb_ID', e.target.value);
                              }}
                            >
                              <MenuItem key="" value="0">
                                Not Selected
                              </MenuItem>
                              {suburbs.map((item) => (
                                <MenuItem key={item.suburb_Id} value={item.suburb_Id}>
                                  {item.suburb_Name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <FormControl fullWidth>
                            <InputLabel id="townLabel">Town</InputLabel>
                            <Select
                              id="physical_Town_ID"
                              value={formik.values.physical_Town_ID}
                              name="physical_Town_ID"
                              fullWidth
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                formik.setFieldValue('physical_Town_ID', e.target.value);
                              }}
                            >
                              <MenuItem key="" value="0">
                                Not Selected
                              </MenuItem>
                              {towns.map((item) => (
                                <MenuItem key={item.town_Id} value={item.town_Id}>
                                  {item.town_Name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="home_Phone" label="Home Phone" />
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="work_Phone" label="Work Phone" />
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Paper variant="outlined">
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="postal_Add1" label="Postal Address" />
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <FormControl fullWidth>
                            <InputLabel id="psuburbLabel">Postal Suburb</InputLabel>
                            <Select
                              id="postal_Suburb_ID"
                              value={formik.values.postal_Suburb_ID}
                              name="postal_Suburb_ID"
                              fullWidth
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                formik.setFieldValue('postal_Suburb_ID', e.target.value);
                              }}
                            >
                              <MenuItem key="" value="0">
                                Not Selected
                              </MenuItem>
                              {suburbs.map((item) => (
                                <MenuItem key={item.suburb_Id} value={item.suburb_Id}>
                                  {item.suburb_Name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <FormControl fullWidth>
                            <InputLabel id="townLabel">Postal Town</InputLabel>
                            <Select
                              id="postal_Town_ID"
                              value={formik.values.postal_Town_ID}
                              name="postal_Town_ID"
                              fullWidth
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                formik.setFieldValue('postal_Town_ID', e.target.value);
                              }}
                            >
                              <MenuItem key="" value="0">
                                Not Selected
                              </MenuItem>
                              {towns.map((item) => (
                                <MenuItem key={item.town_Id} value={item.town_Id}>
                                  {item.town_Name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="postal_Phone" label="Postal Phone" />
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="emailAddress" label="Email Address" />
                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Banking Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    {/* <Grid item xs={12} sm={12}>
                      <Paper elevation={3} marginLeft={1}> */}
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="bank_IDLabel">Bank</InputLabel>
                        <Select
                          id="bank_ID"
                          value={formik.values.bank_ID}
                          name="bank_ID"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('bank_ID', e.target.value);
                            setBranchList(
                              bankBranches.filter((m) => m.bankRefId === e.target.value)
                            );
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {banks.map((item) => (
                            <MenuItem key={item.refId} value={item.refId}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="branchIDLabel">Bank Branch</InputLabel>
                        <Select
                          id="branch_ID"
                          value={formik.values.branch_ID}
                          name="branch_ID"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('branch_ID', e.target.value);
                            const tempCurr = branchList.filter(
                              (item) => item.refId === e.target.value
                            );
                            formik.setFieldValue('sortCode', tempCurr[0].branchCode);
                            console.log('e.target.value', e.target.value);
                            console.log('tempCurr', tempCurr[0].branchCode);
                            console.log('branchList', branchList);
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {branchList.map((item) => (
                            <MenuItem key={item.refId} value={item.refId}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="sortCode" label="Branch Code" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="acc_No" label="Account #" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="accName" label="AccountName" />
                    </Grid>
                    {/* </Paper>
                    </Grid> */}
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Termination Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                      <Controls.DateTime name="termdate" label="Terminated Date" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        name="reasonForTerm"
                        id="reasonForTerm"
                        select
                        fullWidth
                        size="small"
                        label="Reason for Termination"
                        value={formik.values.reasonForTerm}
                        onChange={(e) => {
                          formik.setFieldValue('reasonForTerm', e.target.value);
                        }}
                      >
                        <MenuItem key="" value="0">
                          Not Selected
                        </MenuItem>
                        {terminationReasons.map((option) => (
                          <MenuItem key={option.refId} value={option.name}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Controls.Input name="terminatedBy" label="Approved by" disabled />
                    </Grid>
                    {currentClient.memberStatus === 1 && (
                      <Grid item xs={12} sm={1}>
                        <Button
                          type="submit"
                          variant="outlined"
                          color="error"
                          startIcon={<ThumbDownIcon />}
                          onClick={() => setOperation('terminate')}
                        >
                          Terminate
                        </Button>
                      </Grid>
                    )}
                    {currentClient.memberStatus === 5 && (
                      <Grid item xs={12} sm={1}>
                        <Button
                          type="submit"
                          variant="outlined"
                          color="success"
                          startIcon={<ThumbUpIcon />}
                          onClick={() => setOperation('reinstate')}
                        >
                          Reinstate
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
            <Grid
              margin={2}
              container
              direction="row"
              justifyContent="space-between"
              alignItems="right"
            >
              {!formik.values.passwordCreated && (
                <Grid item xs={12} sm={3} marginRight={1}>
                  <Button
                    type="submit"
                    // style={{ width: 180, height: 30, pb: 2 }}
                    variant="outlined"
                    disabled={isDisabled}
                    startIcon={<FingerprintIcon />}
                    onClick={() => setOperation('registerLogin')}
                  >
                    Create & Send Login...
                  </Button>
                </Grid>
              )}
              {formik.values.passwordCreated && (
                <Grid item xs={12} sm={3} marginRight={1}>
                  <Button
                    type="submit"
                    // style={{ width: 180, height: 30, pb: 2 }}
                    variant="outlined"
                    disabled={isDisabled}
                    startIcon={<FingerprintIcon />}
                    onClick={() => setOperation('resendPassword')}
                  >
                    Resend Password...
                  </Button>
                </Grid>
              )}
              {formik.values.passwordCreated && (
                <Grid item xs={12} sm={3} marginRight={1}>
                  <Button
                    type="submit"
                    // style={{ width: 180, height: 30, pb: 2 }}
                    variant="outlined"
                    disabled={isDisabled}
                    startIcon={<FingerprintIcon />}
                    onClick={() => setOperation('showPassword')}
                  >
                    Show Password...
                  </Button>
                </Grid>
              )}
              <Grid item xs={12} sm={1} marginRight={3}>
                <Button
                  type="submit"
                  variant="outlined"
                  disabled={isDisabled}
                  startIcon={<ThumbUpIcon />}
                  onClick={() => setOperation('save')}
                >
                  Save...
                </Button>
              </Grid>
            </Grid>
          </Form>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </FormikProvider>

        <Controls.Popup title="Add Dependant" openPopup={openPopup} setOpenPopup={setOpenPopup}>
          <DependantSub closePopup={closePopup} />
        </Controls.Popup>
        <Controls.ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
      </CardContent>
    </Card>
  );
}
